<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                :default-expand-all="false"
                style="width: 100%">
                
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="sendNickName" label="发送者" align="center">
                    <template slot-scope="scope">
                        <div>
                            昵称:<span>{{ scope.row.sendNickName }}<span style="color:red;font-size: 17px">{{ scope.row.sendReal ? '*' : '' }}</span></span>
                        </div>
                        <div>
                            ID:{{ scope.row.sendUserId }}
                        </div>
                        <div>
                            状态:
                            <el-tag type="success" v-if="scope.row.sendState == 1">正常</el-tag>
                            <el-tag type="warning" v-if="scope.row.sendState == -1">封禁</el-tag>
                            <el-tag type="danger" v-if="scope.row.sendState == -2">注销</el-tag>
                            <el-tag type="info" v-if="scope.row.sendState == 0">信息未完善</el-tag>
                        </div>
                        <div>
                            城市:{{ scope.row.sendCity }}
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="sendUserId" label="发送者ID" align="center" width="120">
                </el-table-column>
                <el-table-column prop="sendState" label="发送者状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sendState == 1">正常</span>
                        <span v-if="scope.row.sendState == 0">信息未完善</span>
                        <span v-if="scope.row.sendState == -1">封禁</span>
                        <span v-if="scope.row.sendState == -2">注销</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sendCity" label="发送者城市" align="center" width="120">
                </el-table-column> -->
                <el-table-column prop="message" label="消息内容" align="center"></el-table-column>
                <el-table-column prop="toNickName" label="接收者" align="center">
                    <template slot-scope="scope">
                        <div>
                            昵称:<span>{{ scope.row.toNickName }}<span style="color:red;font-size: 17px">{{ scope.row.toReal ? '*' : '' }}</span></span>
                        </div>
                        <div>
                            ID:{{ scope.row.toUserId }}
                        </div>
                        <div>
                            状态:
                            <el-tag type="success" v-if="scope.row.toState == 1">正常</el-tag>
                            <el-tag type="warning" v-if="scope.row.toState == -1">封禁</el-tag>
                            <el-tag type="danger" v-if="scope.row.toState == -2">注销</el-tag>
                            <el-tag type="info" v-if="scope.row.toState == 0">信息未完善</el-tag>
                        </div>
                        <div>
                            城市:{{ scope.row.toCity }}
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="toUserId" label="接收者ID" align="center" width="120">
                </el-table-column>
                <el-table-column prop="toState" label="接收者状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.toState == 1">正常</span>
                        <span v-if="scope.row.toState == 0">信息未完善</span>
                        <span v-if="scope.row.toState == -1">封禁</span>
                        <span v-if="scope.row.toState == -2">注销</span>
                    </template>
                </el-table-column>
                <el-table-column prop="toCity" label="接收者城市" align="center" width="120">
                </el-table-column> -->
                <el-table-column prop="sendTime" label="创建时间" align="center" width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="isDetailDialogShow(scope.row)">对话详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>
        
        
        
        <el-dialog :close-on-click-modal="false" :visible.sync="addMsgDialog" title="回复消息" width="1000px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        发送用户
                    </div>
                    <div class="value" style="width:400px">
                        <el-radio v-model="sendData.sendUserId" :label="selectUserData.userId1" :disabled="selectUserData.real1">{{ selectUserData.nickName1 }}</el-radio>
                        <el-radio v-model="sendData.sendUserId" :label="selectUserData.userId2" :disabled="selectUserData.real2">{{ selectUserData.nickName2 }}</el-radio>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        消息
                    </div>
                    <div class="value" style="width:500px; display: flex; align-items: center;">
                        <el-input v-model="sendData.message" placeholder="" type="textarea"></el-input>
                        <div style="margin-left: 20px;">
                            <el-button type="primary" icon="el-icon-edit" @click="addMsg()">确认</el-button>
                        </div>
                    </div>
                </div>
               
                <div class="list">
                    <el-table
                        :data="detailMsgList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width: 100%">
                        <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                        <el-table-column prop="sendNickName" label="发送用户" align="center" width="120"></el-table-column>
                        <el-table-column prop="message" label="消息内容" align="center"></el-table-column>
                        <el-table-column prop="toNickName" label="接收用户" align="center" width="120"></el-table-column>
                        <el-table-column prop="creationTime" label="创建时间" align="center" width="160px"></el-table-column>
                    </el-table>
                </div>
                
            </div>
        </el-dialog>
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
  

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,
            isDetailDialog:false,
            formData:{},
            formDataAdd:{
                "parentId": "",
                "name": "",
                "sort": 0,
                "imgUrl": "",
                "isShow": true,
            },
            totalCount:0,
            // tableData:[],
            tableData: [
                
            ],

            conditionData:{
                sendUserId: "",
                toUserId: "",
                sendCity: "",
                toCity: "",
                pageSize: 10,
                page: 1
            },
            queryList:[
                {type: "input",label: "发送者ID:",name: "sendUserId"},
                {type: "input",label: "接收者ID:",name: "toUserId"},
                {type: "input",label: "发送者城市:",name: "sendCity"},
                {type: "input",label: "接收者城市:",name: "toCity"}
            ],
           
            addMsgData:{
                "targetId": 0,
                "targetCity": "",
                "targetPhone": "",
                "targetGender": 0,
                "receiverId": 0,
                "receiverCity": "",
                "receiverPhone": "",
                "content": "",
            },
            addMsgDialog:false,

            detailMsgList:[],
            

            conditionMsgData:{
                snapMsgId: null,
                sendPhone: "",
                toPhone: "",
                sendCity: "",
                toCity: "",
                pageSize: 10,
                page: 1
            },
            
            sendData: {
                "sendUserId": null,
                "toUserId": null,
                "message": ""
            },
            selectUserData:{
                nickName1: null, 
                userId1: null, 
                real1: null,
                nickName2: null, 
                userId2: null,
                real2: null,
            }
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();
    },
    methods:{
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.QueryChatSnapMsg(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                sendPhone: "",
                toPhone: "",
                sendCity: "",
                toCity: "",
                pageSize: 10,
                page: 1 
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        async isDetailDialogShow(row){
            // this.$router.push({
            //     name: 'message1',
            //     query:{
            //         id: row.id
            //     }}
            // )
            this.addMsgDialog = true;
            // this.detailMsgList = row;
            if(row){
                this.sendData =  {
                    "sendUserId": null,
                    "toUserId": null,
                    
                    "message": ""
                }
                this.conditionMsgData.snapMsgId = row.id
                this.selectUserData = { 
                    nickName1: row.sendNickName, 
                    userId1: row.sendUserId, 
                    real1: row.sendReal,
                    nickName2: row.toNickName, 
                    userId2: row.toUserId,
                    real2: row.toReal,
                }
            }

            console.log(this.selectUserData);
            let res = await api.QueryChatMsg(this.conditionMsgData);
            this.detailMsgList = res.data.data.data;
            this.detailMsgCount = res.data.data.totalCount;
            
        },
        async addMsg(){
            if(!this.sendData.sendUserId){
                this.$message({
                    message: '请选择发送用户！',
                    type: 'warning'
                });
                return
            }
            if(!this.sendData.message){
                this.$message({
                    message: '请输入发送内容！',
                    type: 'warning'
                });
                return
            }
            if(this.sendData.sendUserId == this.selectUserData.userId1){
                this.sendData.toUserId = this.selectUserData.userId2
            }else{
                this.sendData.toUserId = this.selectUserData.userId1
            }

            let res = await api.SendMsg(this.sendData);
            if(res.data.code==200) {
                this.$message({
                    message: '发送成功',
                    type: 'success'
                });
                this.sendData.message = '';
                this.loadingData();
                this.isDetailDialogShow();
                
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .person{
        height: 700px;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        padding-top: 30px;
        font-size: 14px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
   
</style>
